"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_ROOTS = void 0;

var node_kind_1 = require("./entities/node-kind");

var node_labels_1 = require("./node-labels");

exports.TOP_ROOTS = [];

function addRoot(kind, dn) {
  var label = node_labels_1.NODE_LABELS.get(kind);

  if (!label) {
    throw new Error("Missing Label for " + kind);
  }

  var rootNode = {
    title: label,
    dn: dn,
    kind: kind,
    subNodes: []
  };
  exports.TOP_ROOTS.push(rootNode);
  var builder = {
    subNode: function subNode(subNodeKind) {
      rootNode.subNodes.push(subNodeKind);
      return builder;
    }
  };
  return builder;
}

addRoot(node_kind_1.NodeKind.logic, 'root/logic').subNode(node_kind_1.NodeKind.ns).subNode(node_kind_1.NodeKind.app).subNode(node_kind_1.NodeKind.cont).subNode(node_kind_1.NodeKind.initcont).subNode(node_kind_1.NodeKind.vols).subNode(node_kind_1.NodeKind.vol).subNode(node_kind_1.NodeKind.mounts).subNode(node_kind_1.NodeKind.mount).subNode(node_kind_1.NodeKind.secret).subNode(node_kind_1.NodeKind.configmap).subNode(node_kind_1.NodeKind.replicaset).subNode(node_kind_1.NodeKind.hpa).subNode(node_kind_1.NodeKind.svcaccnt).subNode(node_kind_1.NodeKind.rlbndg).subNode(node_kind_1.NodeKind.crlbndg).subNode(node_kind_1.NodeKind.rl).subNode(node_kind_1.NodeKind.crl).subNode(node_kind_1.NodeKind.pv).subNode(node_kind_1.NodeKind.pvc).subNode(node_kind_1.NodeKind.psp).subNode(node_kind_1.NodeKind.netpols).subNode(node_kind_1.NodeKind.netpol).subNode(node_kind_1.NodeKind.service).subNode(node_kind_1.NodeKind.pod).subNode(node_kind_1.NodeKind.ingress).subNode(node_kind_1.NodeKind.launcher).subNode(node_kind_1.NodeKind.image).subNode(node_kind_1.NodeKind.port);
addRoot(node_kind_1.NodeKind.images, 'root/images').subNode(node_kind_1.NodeKind.repo).subNode(node_kind_1.NodeKind.image).subNode(node_kind_1.NodeKind.tag).subNode(node_kind_1.NodeKind.ns).subNode(node_kind_1.NodeKind.app);
addRoot(node_kind_1.NodeKind.gateway, 'root/gateway').subNode(node_kind_1.NodeKind.domain).subNode(node_kind_1.NodeKind.url).subNode(node_kind_1.NodeKind.ingress).subNode(node_kind_1.NodeKind.service).subNode(node_kind_1.NodeKind.port).subNode(node_kind_1.NodeKind.app).subNode(node_kind_1.NodeKind.traefik_ingress_route).subNode(node_kind_1.NodeKind.traefik_service).subNode(node_kind_1.NodeKind.traefik_middleware).subNode(node_kind_1.NodeKind.traefik_tls_opts);
addRoot(node_kind_1.NodeKind.pack, 'root/pack').subNode(node_kind_1.NodeKind.ns).subNode(node_kind_1.NodeKind.helm).subNode(node_kind_1.NodeKind.version);
addRoot(node_kind_1.NodeKind.k8s, 'root/k8s').subNode(node_kind_1.NodeKind.cluster).subNode(node_kind_1.NodeKind.ns).subNode(node_kind_1.NodeKind.api).subNode(node_kind_1.NodeKind.version).subNode(node_kind_1.NodeKind.kind).subNode(node_kind_1.NodeKind.resource);
addRoot(node_kind_1.NodeKind.infra, 'root/infra').subNode(node_kind_1.NodeKind.nodes).subNode(node_kind_1.NodeKind.pool).subNode(node_kind_1.NodeKind.node).subNode(node_kind_1.NodeKind.storage).subNode(node_kind_1.NodeKind.storclass).subNode(node_kind_1.NodeKind.pv).subNode(node_kind_1.NodeKind.k8s).subNode(node_kind_1.NodeKind.api).subNode(node_kind_1.NodeKind.version).subNode(node_kind_1.NodeKind.kind).subNode(node_kind_1.NodeKind.ns);
addRoot(node_kind_1.NodeKind.rbac, 'root/rbac').subNode(node_kind_1.NodeKind.user).subNode(node_kind_1.NodeKind.group);